import { MediaParticipant } from "@dvrt/web-phone-client";
import ParticipantTile from "./tile/ParticipantTile";
import { Box } from "@mui/material";
import { gridPadding } from "./styles";

const EvenGrid = ({ participants }: { participants: MediaParticipant[] }) => {
    const cols = Math.ceil(Math.sqrt(participants.length));

    return (
        <Box
            sx={{
                display: "grid",
                overflow: "hidden",
                gridTemplateColumns: `repeat(${cols}, 1fr)`,
                height: "100%",
                width: "100%",
                gap: `${gridPadding}px ${gridPadding}px`,
                padding: 0,
            }}
        >
            {participants.map((p) => (
                <ParticipantTile participant={p} key={`${p.cname}-${p.screen}`} />
            ))}
        </Box>
    );
};

export default EvenGrid;
